import { adminLogin, adminLogin_adminLogin, me_me, UserAllDataFragment } from '@api/graphql/types';
import { ApplicationState } from 'reducers';
import { Dispatch, AnyAction } from 'redux';

export enum AuthActionType {
    changeLoginData = '@auth/loginData',
    updateToken = '@auth/updateToken',
    updateAccount = '@auth/updateAccount',
    logout = '@auth/logout',
}

interface ActionType {
    type: AuthActionType;
}

export interface ChangeLoginDataAction extends ActionType {
    adminLoginData: adminLogin | {};
}

export function loginAction(adminLoginData: adminLogin_adminLogin): ChangeLoginDataAction {
    return {
        type: AuthActionType.changeLoginData,
        adminLoginData,
    };
}

export interface UpdateAccountAction extends ActionType {
    user: UserAllDataFragment;
}

export function updateAccount(user: me_me | UserAllDataFragment): UpdateAccountAction {
    return {
        type: AuthActionType.updateAccount,
        user,
    };
}

export function logoutAction() {
    return (dispatch: Dispatch<AnyAction>, getState: () => ApplicationState) => {
        dispatch({ type: AuthActionType.logout });
    };
}

export interface UpdateTokenAction extends ActionType {
    token: string;
}

export function updateToken(token: string): UpdateTokenAction {
    return {
        type: AuthActionType.updateToken,
        token,
    };
}

export type AuthAction = ChangeLoginDataAction | UpdateAccountAction | UpdateTokenAction | ActionType;



// WEBPACK FOOTER //
// ./src/actions/authActions.ts